import { c as _c } from "react/compiler-runtime";
import { Avatar, HStack, Icon, Stack, Text, VStack } from '@chakra-ui/react';
import { MdStarRate } from 'react-icons/md';
interface ClarityCardProps {
  quote?: string;
  personFullName?: string;
  personFirstName?: string;
  personLastName?: string;
  personTitle?: string;
  personAvatarUrl?: string;
  companyName?: string;
  stars?: string;
  bgColor?: string;
  bgGradient?: string;
  color?: string;
}
const ClarityCard: React.FC<ClarityCardProps> = t0 => {
  const $ = _c(21);
  const {
    personFullName,
    personAvatarUrl,
    quote,
    bgColor,
    bgGradient
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon asChild={true} boxSize={12} color="yellow.600"><MdStarRate /></Icon>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon asChild={true} boxSize={12} color="yellow.600"><MdStarRate /></Icon>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon asChild={true} boxSize={12} color="yellow.600"><MdStarRate /></Icon>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon asChild={true} boxSize={12} color="yellow.600"><MdStarRate /></Icon>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Stack align="flex-start" direction="column" gap={2}><HStack gap={0.5}>{t1}{t2}{t3}{t4}<Icon asChild={true} boxSize={12} color="yellow.600"><MdStarRate /></Icon></HStack></Stack>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== quote) {
    t6 = <VStack align="flex-start" gap={4}><Text color="textPrimaryAlpha.800" fontSize="md">{quote}</Text></VStack>;
    $[5] = quote;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== personAvatarUrl) {
    t7 = personAvatarUrl ? <Avatar.Root bgColor="primary" size="xs"><Avatar.Fallback /><Avatar.Image src={personAvatarUrl} /></Avatar.Root> : undefined;
    $[7] = personAvatarUrl;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== personFullName) {
    t8 = <Text textStyle="labelSm">{personFullName}</Text>;
    $[9] = personFullName;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <HStack>{t7}{t8}</HStack>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t9) {
    t10 = <VStack align="flex-start" gap={8} padding={8}>{t5}{t6}{t9}</VStack>;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== bgColor || $[18] !== bgGradient || $[19] !== t10) {
    t11 = <Stack align="flex-start" bg={bgGradient} bgColor={bgColor} borderRadius="2xl" boxShadow="sm" overflow="hidden" width="full">{t10}</Stack>;
    $[17] = bgColor;
    $[18] = bgGradient;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
export default ClarityCard;